<!-- =========================================================================================
  File Name: EditDomain.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="Question Not Found" :active.sync="errorOccurred">
      <span>Question record with id: {{ $route.params.questionId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'admin-list-content-question' }" class="text-inherit underline">All Questions</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="questionData">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <question-details-tab class="mt-4" :data="questionData" v-on:update_questionData="update_questionData" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import QuestionDetailsTab from './QuestionDetailsTab.vue'

export default {
  components: {
    QuestionDetailsTab
  },
  data () {
    return {
      questionData: null,
      errorOccurred: false,

      activeTab: 0
    }
  },
  methods: {
    loadQuestionData () {
      this.$http
        .get(`testprep/questions/${this.$route.params.questionId}`)
        .then((response) => {
          if (response.status === 200) {
            this.questionData = response.data.data
          }
        })
        .catch((error) => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    update_questionData (data) {
      const pl = {
        ...data,
        domain_id: data.domain_id === '' ? null : data.domain_id
      }

      if (pl.question === undefined) {
        return this.$vs.notify({
          title: 'Failed to update question',
          text: 'Please provide a question',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$vs.loading()

      this.$http
        .post(`testprep/questions/${this.$route.params.questionId}`, pl)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Question Successfully',
              text: 'Question has been updated.',
              color: 'success',
              position: 'top-right'
            })
            return this.loadQuestionData()
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this question'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update question',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.loadQuestionData(this.$route.params.questionId)
  }
}
</script>
